// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { AlertService } from '@app/core/services/alert.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { RolesService, readParameterFromRouterState, RoleGroupScope, RoleGroupSelections } from '@app/core';
import { GroupDetailsFacadeService } from '@app/access-management/state/group-details/group-details.facade';
import { tap, map } from 'rxjs/operators';
import { DataTableAjaxComponent, SelectedRows } from '@app/shared/data-table-ajax/data-table-ajax.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralDeleteModalComponent } from '@app/access-management/shared/delete-modal/delete-modal.component';
import { RoleScopeFacadeService } from '@app/access-management/state/role-scole.facade';

@Component({
    selector: 'app-role-details-group-scopes',
    templateUrl: './role-details-group-scopes.component.html'
})
export class RoleDetailsGroupScopesComponent implements OnInit, AfterViewInit {

    @ViewChild('actionTemplate') actionTemplate: any;
    @ViewChild('dataTableAjax') dataTableAjax!: DataTableAjaxComponent;

    roleId: any;
    groupId: any;
    group$: any;
    roleGroupScopesColumn: any[] = [];
    scopes$: any;
    _selectedCategory: any;

    scopeNamesTable = [
        {
          name: 'Name',
          prop: 'name',
          flexGrow: 2
        }
      ];
    _selectedConstraints: any;
    addScopeMode = false;
    roleGroupScopes$: any;

    constructor(
        private route: ActivatedRoute,
        private modalService: NgbModal,
        private groupDetailsFacadeService: GroupDetailsFacadeService,
        private scopeFacadeService: RoleScopeFacadeService,
        private alertService: AlertService,
        private roleService: RolesService,
        ) {
        this.roleId = readParameterFromRouterState(this.route, 'id');
        this.groupId = readParameterFromRouterState(this.route, 'groupId');

        this.groupDetailsFacadeService.initialize(this.groupId);
        this.group$ = this.groupDetailsFacadeService.groupDetails$;

        this.scopeFacadeService.initializeCategories();
        this.scopes$ = this.scopeFacadeService.categories$;

        this.roleGroupScopes$ = this.roleService.getRoleGroupScopes(this.roleId, this.groupId)
            .pipe(map(list => [...list.map(row => ({...row, id: row.object_id}))]));
    }

    ngOnInit(): void { }

    ngAfterViewInit () {
        this.loadColumns();
    }

    addScopes () {
        this.addScopeMode = true;
        this.resetSelectedValues();
    }

    onSelectCategory (data: any) {
        this._selectedCategory = data;
    }

    cancel () {
        this.addScopeMode  = false;
        this.resetSelectedValues();
    }

    resetSelectedValues () {
        this._selectedCategory = undefined;
        this._selectedConstraints = undefined;
    }

    submit () {
        if (!this.isValid()) {
            return;
        }

        const request: RoleGroupSelections =  {
            groups: [ { group_id: this.groupId}] as any,
            category: this._selectedCategory,
            constraints: this._selectedConstraints
        };

        this.roleService.addGroupsToRole(this.roleId, request, this._selectedCategory).subscribe(
            () => {
                this.addScopeMode = false;
                this.alertService.success('Scope Names Added successfully');
                this.dataTableAjax.refreshTable();
                this.resetSelectedValues();
            },
            () => {
                this.alertService.error('Save Scope Names failed');
            }
        );
    }

    isValid () {
        return this._selectedCategory && this._selectedConstraints;
    }

    loadColumns () {
        this.roleGroupScopesColumn = [
            {
                name: 'Scope',
                prop: 'object_type_name',
                flexGrow: 1
            },
            {
              name: 'Scope Name',
              prop: 'object_name',
              headerClass: 'ml-8',
              flexGrow: 2
            },
            {
              name: 'Actions',
              cellTemplate: this.actionTemplate,
              flexGrow: 1
            },
          ];
    }

    onSelectScopeNames (rows: SelectedRows) {
        this._selectedConstraints = rows.selected;
    }


    onRemoveRow(row: RoleGroupScope) {

        const ModalFixture = this.modalService.open(GeneralDeleteModalComponent, { centered: true, windowClass: 'no-border' });
        const modal: GeneralDeleteModalComponent = ModalFixture.componentInstance;

        modal.observable = this.roleService.removeRoleGrantId(this.roleId, row.grant_id);

        modal.onSuccessRemove = () => {
            this.alertService.success('Scope Name delete succeed.');
          modal.close();
          this.dataTableAjax.refreshTable();
        };

        modal.onFailRemove = () => {
            this.alertService.error('Scope Name delete Failed');
        };
      }
}



// WEBPACK FOOTER //
// ./src/app/access-management/roles/role-details/role-details-groups-tab/role-details-group-scopes/role-details-group-scopes.component.ts